import Header from '@lightbox/kendo-react-toolkit/composite/Header';
import { useOktaAuth } from '@okta/okta-react';
import PropTypes from 'prop-types';
import React from 'react';
import Hero from '../images/hero.png';
import { getEnv } from '../utils/helpers';

function AppHeader(props) {
    const { user } = props;
    const { oktaAuth } = useOktaAuth();
    const accountSettings = [{
        icon: ['fas', 'users'],
        name: 'Manage My LightBox Account',
        url: getEnv('REACT_APP_OKTA_USER_PROFILE'),
        visible: true,
    }];

    return (
        <div id="app-header-wrapper">
            <Header
                hideLogo
                id="app-header"
                supportButton={{
                    id: getEnv('REACT_APP_INTERCOM_LAUNCHER_SELECTOR'),
                }}
                userAccount={{
                    accountSettings,
                    hideLinkedAccounts: true,
                    onSignOut: () => {
                        oktaAuth.tokenManager.clear();
                        window.location.href = getEnv('REACT_APP_OKTA_LOGOUT_REDIRECT');
                    },
                    user: {
                        email: user.email,
                        name: user.name,
                    },
                }}
            />
            <img alt="LightBox Valuation Hero" id="hero" src={Hero} />
        </div>
    );
}

AppHeader.propTypes = {
    user: PropTypes.shape({
        email: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
};

export default AppHeader;
